import { REQUEST_GET_USER_SUCCESS } from "./types";

export const setUser = (user) => ({
  type: REQUEST_GET_USER_SUCCESS,
  payload: {
    user,
    __persisted_at: Date.now(),
  },
});
